import React from 'react';
import { Controller } from 'react-hook-form';
import { MyMDatePicker } from '../ui-elements/MyMDatePicker';


/**
 * 入力チェック用DatePicker Component
 */
const ValidatableDatePicker = ({ control, name, value, rules, formState, width, color, onChange }) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={value}
      render={({ field: { ref, ...field } }) =>
        <MyMDatePicker
          {...field}
          value={value}
          color={color}
          onChange={((e) => {
            field.onChange(e);
            onChange && onChange(e);
          })}
          selected={value}
          formState={formState}
          name={name}
          sx={{ width: width }}
        />
      }
      rules={rules}
    />




  );


};
export default ValidatableDatePicker;
